import { getCookie } from '@susu/cookie'

/**
 * Get Google and Facebook attributes from cookies
 * @returns {fbFbc: string, fbFbp: string, gaAwClid: string}
 */
export const getGoogleAndFacebookAttributesFromCookies = (): {
  fbFbc: string
  fbFbp: string
  gaAwClid: string
} => {
  const fbFbc = getCookie('_fbc') ?? ''
  const fbFbp = getCookie('_fbp') ?? ''
  const gaAwClid = getCookie('_gcl_aw')?.split('.')[2] ?? ''

  return { fbFbc, fbFbp, gaAwClid }
}
